export default __webpack_public_path__ + "static/media/promo_ufc.1290c96a.svg";